import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class TicketSystemService {

  url = "https://niivsnes.humge.com";
  constructor(private http: HttpClient, private logService: LogService) { 
  }

  getAllTickets(data): Observable<any> {
    return this.http.post(this.url + '/api/filterTickets?token='+localStorage.getItem('token'),data);
  }

  deleteTechnicians(id): Observable<any> {
    this.logService.log("Изтриване на резултат " + id).subscribe();
    return this.http.delete(this.url + '/api/ticket/' + id+'?token='+localStorage.getItem('token'));
  }

  saveTicket(request): Observable<any> {
    this.logService.log("Добавяне на резултат ").subscribe();
    return this.http.post(this.url + '/api/ticket?token='+localStorage.getItem('token'), request);
  }

  editTicket(id): Observable<any> {
    return this.http.get(this.url + '/api/ticket/' + id + '/edit?token='+localStorage.getItem('token'));
  }

  updateTicket(request, id): Observable<any> {
    this.logService.log("Промяна на резултат " + id).subscribe();
    return this.http.put(this.url + '/api/ticket/' + id+'?token='+localStorage.getItem('token'), request);
  }

  getAllTicket(data): Observable<any> {
    return this.http.post(this.url + '/api/ticketRequests?token='+localStorage.getItem('token'),data);
  }

  checkTechnicianId(data): Observable<any> {
    return this.http.post(this.url + '/api/checkTechnicianId?token='+localStorage.getItem('token'),data);
  }


}
